import PageWrapper from "@/pages/PageWrapper";
import Intro from "@/sections/Intro";
import useSEO from "@/lib/useSEO";

export default function StudioPage() {
    useSEO({
        title: "About the Studio — ate.teen studio, Kollam Kerala",
        description:
            "Meet ate.teen studio: an architecture practice in Kollam, Kerala led by Ar. Abhishek Aji, focused on contemporary residential design, material honesty and site-specific architecture.",
        path: "/studio",
    });
    return (
        <PageWrapper className="pt-24">
            <h1 className="sr-only">
                About ate.teen studio — contemporary architecture practice in Kollam, Kerala
            </h1>
            <Intro />
        </PageWrapper>
    );
}
